module.exports = __webpack_public_path__ + "img/info4_b.2866cd51.svg";